import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "prideSpecial" && !(_id in path('drafts.**'))][0]{
    content,
    titleImage,
    titleImageMobile,
    image,
    ogImage,
    prideSpecialCards[]->{
        name,
        publishedAt,
        image,
        text,
      } | order(publishedAt desc),
  }`;
}
